export default "__VITE_ASSET__fe3a8eed__"